import { errorToast, toast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useInvitationResendManyMutation } from "@/v2-backoffice-client/invitation/resend/many/invitation.resend.many.mutation"

export type InvitationResendManyButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  invitationIds: number[]
  onCompleted?(): void
}

function InvitationResendManyButton(props: InvitationResendManyButtonProps) {
  const { invitationIds, confirmContent, onCompleted, ...confirmButtonProps } =
    props

  const invitationCount = invitationIds.length

  const [resendManyInvitations, { loading, error }] =
    useInvitationResendManyMutation({
      onCompleted(data) {
        const sent = data.resendManyUserInvitations.length
        toast({
          variant: "success",
          title: `Resent ${sent} of ${invitationCount} invitation${invitationCount === 1 ? "" : "s"}`,
        })
        onCompleted?.()
      },
    })

  errorToast(error, {
    title: `Failed to resend ${invitationCount} invitation(s)`,
  })

  return (
    <ConfirmButton
      id="invitation-resend-many-button"
      variant="ghost"
      size="tiny"
      iconSrc="paper-plane"
      content="Resend invitations"
      confirmVariant="warning"
      confirmContent={
        confirmContent ??
        `Are you sure you want to resend ${invitationCount} invitation(s)?`
      }
      isLoading={loading}
      onConfirm={() => {
        resendManyInvitations({ variables: { ids: invitationIds } })
      }}
      {...confirmButtonProps}
    />
  )
}

export default InvitationResendManyButton
